import React from 'react';
import { CareTeamMemberType } from './types';
import { CareTeamMemberDetails } from '../../../primary-record-types/apiTypes/medicalProfileService';
import { useIsDisabledByParent } from '../../v2BaseComponents/IsDisabledProvider';
import CareTeamTypeSelect from './CareTeamTypeSelect';
import { SelectCareTeamMemberTypeContext } from './SelectCareTeamMemberTypeContext';
import { ActionButtonLayout } from '../../v2BaseComponents/ActionButtonLayout';
import MainContentContainer from '../../v2BaseComponents/MainContentContainer';

export type CareTeamTypeConditionalRenderContainerOwnProps = {
    isDisabled?: boolean;
    areUpdatesDisabled: boolean;
    initialCareTeamMemberDetails: CareTeamMemberDetails | null;
    children: (selectedCareTeamMemberType: CareTeamMemberType) => React.ReactNode;
    renderNullCareTeamSelectInActionButtonContainer?: boolean;
};

export type CareTeamTypeConditionalRenderContainerProps = CareTeamTypeConditionalRenderContainerOwnProps;

const CareTeamTypeConditionalRenderContainer: React.FC<CareTeamTypeConditionalRenderContainerProps> = (props) => {
    const [selectedCareTeamMemberType, setSelectedCareTeamMemberType] = React.useState<CareTeamMemberType | null>(
        () => {
            if (!props.initialCareTeamMemberDetails) return null;

            if (props.initialCareTeamMemberDetails.contactDetails.contactType === 'support-care-team-member') {
                return 'support';
            } else if (props.initialCareTeamMemberDetails.contactDetails.contactType === 'provider-care-team-member') {
                return 'provider';
            } else if (props.initialCareTeamMemberDetails.contactDetails.contactType === 'insurance-care-team-member') {
                return 'insurance';
            }

            return null;
        },
    );
    const isDisabledByParent = useIsDisabledByParent(props.isDisabled);

    const careTeamSelect = <CareTeamTypeSelect value={null} isDisabled={isDisabledByParent} />;

    return (
        <SelectCareTeamMemberTypeContext.Provider
            value={{
                selectCareTeamMemberType:
                    props.isDisabled || props.areUpdatesDisabled ? () => {} : setSelectedCareTeamMemberType,
                areUpdatesDisabled: props.areUpdatesDisabled,
            }}
        >
            <React.Fragment key={selectedCareTeamMemberType}>
                {!selectedCareTeamMemberType ? (
                    props.renderNullCareTeamSelectInActionButtonContainer ? (
                        <ActionButtonLayout whiteBackground>
                            <MainContentContainer>{careTeamSelect}</MainContentContainer>
                        </ActionButtonLayout>
                    ) : (
                        careTeamSelect
                    )
                ) : (
                    props.children(selectedCareTeamMemberType)
                )}
            </React.Fragment>
        </SelectCareTeamMemberTypeContext.Provider>
    );
};

export default React.memo(CareTeamTypeConditionalRenderContainer);
